import { render, staticRenderFns } from "./ReceiptConfiguration.vue?vue&type=template&id=d61a477e&scoped=true"
import script from "./ReceiptConfiguration.vue?vue&type=script&lang=js"
export * from "./ReceiptConfiguration.vue?vue&type=script&lang=js"
import style0 from "./ReceiptConfiguration.vue?vue&type=style&index=0&id=d61a477e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d61a477e",
  null
  
)

export default component.exports